import React from 'react';
import { Modal, Button, PaperClip } from 'components';
import { AdvertisementService } from 'services';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';

interface Props {
    onClose: () => void;
    onSuccess: () => void;
    item: any;
}

class ModalEdit extends React.Component<Props> {
    state = {
        form: {
            title: '',
            content: '',
            document: '',
            days: '',
        },
        total_amount: '0.00'
    };

    componentDidMount() {
        if (this.props.item) {
            const detail = this.props.item.details?.[0] || {};
            const initialDays = this.props.item.days?.toString() || '30';

            this.setState({
                form: {
                    title: detail.title || '',
                    content: detail.content || '',
                    days: initialDays,
                    document: '',
                },
                total_amount: this.calculatetotal_amount(initialDays)
            });
        }
    }

    calculatetotal_amount = (days: string) => {
        const numDays = parseInt(days) || 30;
        const baseAmount = parseFloat(this.props.item?.classified_rate?.amount) || 0;
        const total = (numDays / 30) * baseAmount;

        return total.toFixed(2);
    };

    change = (e: any) => {
        const { name, value } = e.target;

        this.setState((prevState: any) => {
            const newState = {
                form: {
                    ...prevState.form,
                    [name]: value
                },
                total_amount: prevState.total_amount
            };
            if (name === 'days') {
                newState.total_amount = this.calculatetotal_amount(value);
            }

            return newState;
        });
    };

    submit = async (e: any) => {
        e.preventDefault();
        try {
            await AdvertisementService.admin.update({
                user_id: this.props.item.user_id,
                type: this.props.item.type,
                id: this.props.item.id,
                ...this.state.form,
                // @ts-ignore
                document: this.state.form.document?.value || '',
                hasFile: !!this.state.form.document
            });

            Globals.showSuccess("Clasificado actualizado correctamente");
            this.props.onSuccess();
        } catch (error) {
            console.error("Error actualizando:", error);
        }
    };

    render() {
        const currentDocument = this.props.item?.details?.[0]?.document
            ? `${Constants.BASE_STORAGE}${this.props.item.details[0].document}`
            : WhiteImage;

        // @ts-ignore
        const fileName = this.state.form.document?.file?.name || 'picture.IMG';

        return (
            <>
                <style>{`
                    .modal-edit-classified .modal-content {
                        border-radius: 16px !important;
                        border: none !important;
                        background-color: #ffffff !important;
                        box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15) !important;
                    }
                    .modal-edit-classified .modal-header {
                        background-color: #ffffff !important;
                        border-bottom: none !important;
                        border-radius: 16px 16px 0 0 !important;
                        padding: 24px 24px 10px 24px !important;
                    }
                    .modal-edit-classified .modal-title {
                        font-size: 1.15rem !important;
                        font-weight: 800 !important;
                        color: #000000 !important;
                    }
                    .modal-edit-classified .close {
                        position: absolute !important;
                        top: 20px !important;
                        right: 20px !important;
                        font-size: 1.5rem !important;
                        color: #000000 !important;
                        opacity: 0.5 !important;
                    }
                    .modal-edit-classified .modal-body {
                        padding: 10px 24px 24px 24px !important;
                        background: #fff !important;
                        border-radius: 0 0 16px 16px !important;
                    }
                    
                    /* Forzamos alturas iguales para alinear verticalmente */
                    .custom-input-height {
                        height: 42px !important;
                        border-radius: 8px !important;
                    }
                    .modal-edit-classified input.form-control,
                    .modal-edit-classified select.form-control {
                        height: 42px !important;
                        border-radius: 8px !important;
                        border: 1px solid #ced4da !important;
                    }
                    .modal-edit-classified textarea.form-control {
                        border-radius: 8px !important;
                        border: 1px solid #ced4da !important;
                    }
                    .input-label-custom {
                        font-size: 0.75rem !important;
                        font-weight: 700 !important;
                        color: #333333 !important;
                        margin-bottom: 6px !important;
                        display: block !important;
                    }

                    /* Botones exactos al diseño */
                    .btn-cancel-custom {
                        background-color: #ffffff !important;
                        border: 1px solid #d1d5db !important;
                        color: #000000 !important;
                        border-radius: 30px !important;
                        font-weight: 600 !important;
                        padding: 10px 0 !important;
                        width: 140px;
                        font-size: 0.95rem !important;
                    }
                    .btn-save-custom {
                        background-color: #6e8b3d !important; /* Verde oliva del diseño */
                        border: none !important;
                        color: #ffffff !important;
                        border-radius: 30px !important;
                        font-weight: 600 !important;
                        padding: 10px 0 !important;
                        width: 140px;
                        font-size: 0.95rem !important;
                    }

                    /* Ocultamos cualquier clip verde global que venga del componente PaperClip */
                    .modal-edit-classified .paperclip-image > img, 
                    .modal-edit-classified .paperclip-image > svg,
                    .modal-edit-classified .paperclip-image > i {
                        display: none !important; 
                    }
                `}</style>

                <Modal
                    className="modal-edit-classified"
                    visible={true}
                    onClose={this.props.onClose}
                    title="Editar"
                    size="md"
                >
                    <form onSubmit={this.submit}>

                        <div className="row mb-3 d-flex align-items-end">
                            <div className="col-md-7">
                                <label className="input-label-custom">Titulo de clasificado</label>
                                <input
                                    className="form-control custom-input-height"
                                    value={this.state.form.title}
                                    name="title"
                                    onChange={this.change}
                                />
                            </div>
                            <div className="col-md-5">
                                <label className="input-label-custom">Cedula</label>
                                <PaperClip
                                    className="paperclip-image w-100"
                                    value={this.state.form.document}
                                    onChange={(e: any) => this.change({ target: { name: 'document', value: e.target } })}
                                >
                                    <div
                                        className="custom-input-height"
                                        style={{
                                            backgroundColor: '#d1dca3',
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '0 10px',
                                            cursor: 'pointer',
                                            width: '100%',
                                            border: 'none'
                                        }}
                                    >
                                        <img
                                            style={{
                                                width: '30px',
                                                height: '30px',
                                                objectFit: 'cover',
                                                borderRadius: '4px',
                                                backgroundColor: '#fff',
                                                flexShrink: 0
                                            }}
                                            /* @ts-ignore */
                                            src={this.state.form.document?.dataURL || currentDocument}
                                            alt="Cédula"
                                        />
                                        <span style={{
                                            fontSize: '0.8rem',
                                            color: '#000',
                                            fontWeight: 600,
                                            marginLeft: '10px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}>
                                            {fileName}
                                        </span>
                                    </div>
                                </PaperClip>
                            </div>
                        </div>

                        <div className="row mb-4">
                            <div className="col-12">
                                <label className="input-label-custom">Contenido anuncio</label>
                                <textarea
                                    className="form-control"
                                    name="content"
                                    rows={4}
                                    value={this.state.form.content}
                                    onChange={this.change}
                                    style={{ resize: 'none' }}
                                ></textarea>
                            </div>
                        </div>

                        <div className="row mb-4 align-items-end">
                            <div className="col-md-6">
                                <label className="input-label-custom">Tiempo a contratar (días)</label>
                                <select
                                    className="form-control custom-input-height"
                                    name="days"
                                    onChange={this.change}
                                    value={this.state.form.days}
                                >
                                    <option value="30">30</option>
                                    <option value="60">60</option>
                                    <option value="90">90</option>
                                </select>
                            </div>
                            <div className="col-md-6 text-right d-flex flex-column justify-content-end" style={{ height: '42px' }}>
                                <span style={{
                                    fontSize: '0.75rem',
                                    fontWeight: 700,
                                    color: '#333',
                                    marginBottom: '-2px'
                                }}>Monto</span>
                                <span style={{
                                    fontSize: '1.4rem',
                                    fontWeight: 800,
                                    color: '#000',
                                    lineHeight: '1'
                                }}>${this.state.total_amount}</span>
                            </div>
                        </div>

                        <div className="d-flex justify-content-center mt-4 pt-2" style={{ gap: '15px' }}>
                            <Button
                                type="button"
                                className="btn-cancel-custom"
                                onClick={this.props.onClose}
                            >
                                Cerrar
                            </Button>
                            <Button
                                type="submit"
                                className="btn-save-custom"
                            >
                                Guardar
                            </Button>
                        </div>

                    </form>
                </Modal>
            </>
        );
    }
}

export default ModalEdit;